










import {Component, Prop, Vue} from 'vue-property-decorator';
import {WidgetSettings} from '@c/widgets/base/bindForms/interfaces';

@Component({})
export default class WidgetSettingsForm extends Vue {
  valid = true;

  @Prop({required: false})
  initSettings!: WidgetSettings;

  settings: WidgetSettings = {
    name: '',
  };

  created() {
    if (this.initSettings) this.settings = this.initSettings;
  }
}
